<template>
  <v-container>
    <v-dialog
      v-model="basketDialog"
      max-width="700px"
      transition="dialog-transition"
      v-if="basketDialog"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pt-3 px-3 pb-0': $vuetify.breakpoint.smAndDown}">
          <h2 class="mb-3">{{item.nazev}}</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap align-center>
            <v-flex xs12 sm4 :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
              <img class="mb-3 img-detail" v-img:group1 v-if="item.obrazky == null || item.obrazky.length == 0" src="@/assets/images/item.png" :alt="item.nazev">
              <img class="mb-3 img-detail" v-img:group1 v-else :src="$imagesBaseUrl + item.obrazky[0].s3_nazev" :alt="item.nazev">
            </v-flex>
            <v-flex xs12 sm8 :class="{'pl-3': $vuetify.breakpoint.smAndUp}">
              <p>
                <strong>{{item.kratky_popis}}</strong>
              </p>
              <v-layout row wrap align-end>
                <v-flex xs12 sm9 v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i==0">
                  <p class="grey--text caption mb-1 bold">Cena s DPH:</p>
                  <strong class="h2 text-primary">{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</strong>
                  <p class="grey--text mb-0 bold fs-14"><span v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i>0"><span v-if="i>1"> / </span>{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</span></p>
                </v-flex>
                <v-flex xs12 sm3 class="d-flex justify-end">
                  <v-text-field
                    class="item-ks"
                    placeholder="Počet"
                    hide-controls
                    hide-details
                    type="number"
                    solo
                    suffix="Ks"
                    v-model="mnozstvi"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="grey lighten-1 elevation-0" class="bold ma-0 mr-3 mt-3" dark block large @click="basketDialog=false">Zrušit</v-btn>
                <v-btn color="orange elevation-0" class="bold ma-0 mt-3" dark block large @click="addBasket">Přidat do košíku</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addBasketDialog"
      max-width="700px"
      transition="dialog-transition"
      v-if="addBasketDialog"
    >
      <v-card>
        <v-card-title class="justify-center pa-0">
          <h2 class="mb-3">Zboží bylo přidáno do košíku.</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-btn color="grey lighten-1 elevation-0" class="bold ma-0 mr-3 mt-3" dark block large @click="addBasketDialog=false">Pokračovat v nákupu</v-btn>
            <button-link color="orange elevation-0" class="bold ma-0 mt-3" dark block large :to="{ path: '/kosik' }">Přejít do košíku</button-link>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="account" :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap align-center class="mb-5">
            <v-flex xs12 sm6>
              <img class="mb-3 img-detail" v-img:group1 v-if="item.obrazky == null || item.obrazky.length == 0" src="@/assets/images/item.png" :alt="item.nazev">
              <img class="mb-3 img-detail" v-img:group1 v-else :src="$imagesBaseUrl + item.obrazky[0].s3_nazev" :alt="item.nazev">
            </v-flex>
            <v-flex xs12 sm6>
              <h1 class="mb-3">{{item.nazev}}</h1>
              <p>
                {{item.kratky_popis}}
              </p>
              <v-chip label color="" class="mx-0 white--text green--label" v-if="item.akcni_cena">Akční produkt</v-chip>
              <v-layout row wrap align-end v-if="item.akcni_cena && item.stara_cena != null && item.stara_cena.toString().length > 0" class="mt-2">
                <v-flex xs12 sm6>
                  <p class="grey--text caption mb-1 bold">
                    Stará cena:
                  </p>
                  <strong class="h2 grey--text line-through">{{item.stara_cena | formatMoney}} Kč</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap align-end>
                <v-flex xs12 sm6 v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i==0">
                  <p class="grey--text caption mb-1 bold">
                    <span v-if="item.akcni_cena">Nová akční cena s DPH:</span>
                    <span v-else>Cena s DPH:</span>
                  </p>
                  <strong class="h2 text-primary">{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</strong>
                  <p class="grey--text mb-0 bold fs-14"><span v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i>0"><span v-if="i>1"> / </span>{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</span></p>
                </v-flex>
                <v-flex xs12 sm5>
                  <template v-if="item && item.aktivni === 1">
                    <v-btn
                        color="orange elevation-0"
                        class="bold ma-0 mt-3"
                        dark
                        block
                        large
                        @click="koupit"
                    >
                      Koupit
                    </v-btn>
                  </template>

                  <template v-else>
                    <div
                        class="grey lighten-2 text-center font-weight-bold py-4 mt-3"
                        style="border-radius: 4px; color: #777;"
                    >
                      Produkt momentálně nelze zakoupit
                    </div>
                  </template>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="mb-5">
            <v-flex xs12>
              <p class="grey--text caption mb-1 bold">Detailní popis:</p>
              <p class="text-xs-justify mb-0">
                <strong>
                  {{item.detailni_popis}}
               </strong>
             </p>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="detail-info__row" v-if="item.typ_produktu != 'staticky'">
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Kategorie:</p>
              <strong v-if="item.kategorie.nazev">{{item.kategorie.nazev}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Materiál:</p>
              <strong v-if="item.material.nazev">{{item.material.nazev}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Ryzost:</p>
              <strong v-if="item.ryzost">{{item.ryzost}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Váha:</p>
              <strong v-if="item.vaha">{{item.vaha}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Rozměry:</p>
              <strong v-if="item.rozmery">{{item.rozmery}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Země původu:</p>
              <strong v-if="item.zeme_puvodu.nazev">{{item.zeme_puvodu.nazev}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Výrobce:</p>
              <strong v-if="item.vyrobce.nazev">{{item.vyrobce.nazev}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Rok ražby:</p>
              <strong v-if="item.rok_razby">{{item.rok_razby}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Motiv:</p>
              <strong v-if="item.motiv">{{item.motiv}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Nominální hodnota:</p>
              <strong v-if="item.nominalni_hodnota">{{item.nominalni_hodnota}}</strong>
              <strong v-else>--</strong>
            </v-flex>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Balení:</p>
              <strong v-if="item.baleni">{{item.baleni}}</strong>
              <strong v-else>--</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="detail-info__row" v-else>
            <v-flex xs6 sm6 md4 class="mb-20 px-2">
              <p class="grey--text caption mb-1 bold">Kategorie:</p>
              <strong v-if="item.kategorie.nazev">{{item.kategorie.nazev}}</strong>
              <strong v-else>--</strong>
            </v-flex>
          </v-layout>
          <hr class="account__hr">
          <v-layout row wrap align-center class="mb-30">
            <v-flex xs12 sm6>
              <h2>Obrázky</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center text-md-left">
              <img class="mb-3 img-detail__small" v-img:group1 v-if="item.obrazky == null || item.obrazky.length == 0" src="@/assets/images/item.png" :alt="item.nazev">
              <v-layout v-else>
                <v-flex sm2 class="text-xs-center" v-for="o in item.obrazky">
                  <img class="mb-3 img-detail__small" v-img:group1 :src="$imagesBaseUrl + o.s3_nazev" :alt="item.nazev">
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <hr class="account__hr">
          <v-layout row wrap align-center class="mb-30">
            <v-flex xs12 sm6>
              <h2>Aktuální ceny</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="item.aktualni_ceny"
                hide-controls
                class="elevation-0"
              >
                <template v-slot:items="props">
                  <td>{{props.item.mena.nazev}}</td>
                  <td class="text-xs-right">{{ props.item.prodejni_cena_bez_dph | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td class="text-xs-right">{{ props.item.prodejni_cena_dph | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td class="text-xs-right">{{ props.item.prodejni_cena | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td v-if="item.skryt_eshop_vykup_cena === false" class="text-xs-right">{{ props.item.vykupni_cena | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td v-else class="text-xs-right">Cena na dotaz</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <hr class="account__hr">
          <v-layout row wrap align-center class="mb-30">
            <v-flex xs12 sm6>
              <h2>Vývoj cen</h2>
            </v-flex>
          </v-layout>
          <v-card class="white no__radius mt-4" v-if="chartLoaded" v-for="(chart, n) in charts" :key="'price-chart-' + n.toString()">
            <v-card-text class="px-0 pb-0">
              <apexchart width="100%" height="300" type="line" :options="chart.options" :series="chart.series"></apexchart>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        headers: [
          { text: 'Měna', value: 'mena.nazev', sortable: false },
          { text: 'Prodejní cena bez DPH', value: 'bez_dph', sortable: false, align: 'right'},
          { text: 'DPH', value: 'dph', sortable: false, align: 'right' },
          { text: 'Prodejní cena s DPH', value: 's_dph', sortable: false, align: 'right' },
          { text: 'Výkupní cena', value: 'vykupni_cena', sortable: false, align: 'right' }
        ],
        produkt: null,
        dialogUdaje: false,
        basketDialog: false,
        addBasketDialog: false,
        item: null,
        itemsSelect: [
          'Ano',
          'Ne'
        ],
        rulesRequired: [
          (v) => !!v || "Pole je vyžadováno"
        ],
        charts: [],
        chartLoaded: false,
        mnozstvi: 1
      }
    },
    props: {
      id: String
    },
    mounted () {
      this.load();
      this.loadVyvojCen();
    },
    methods: {
      load: function() {
        window.API.get("produkty/"+this.id).then(function(body) {
          this.item = body;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      loadVyvojCen () {
        window.api.get("produkty/" + this.$props.id + "/vyvoj-cen").then((_body) => {
          this.charts = [];
          var series = [];
          for (var $i = 0; $i < _body.prodejni_ceny.length; $i++) {
            var _zkratka = _body.prodejni_ceny[$i].mena.zkratka;
            this.charts.push({
              options: {
                title: {
                  text: "Prodej " + _body.prodejni_ceny[$i].mena.identifikator,
                  align: "center",
                  style: {
                    fontSize:  '22px'
                  },
                },
                chart: {
                  id: 'produkt-price-prodej-' + _body.prodejni_ceny[$i].mena.identifikator
                },
                xaxis: {
                  type: "datetime",
                  labels: {
                    formatter: function (value) {
                      return moment(value*1000).format("D.M.Y HH:mm");
                    }
                  }
                },
                yaxis: {
                  min: _body.prodejni_ceny[$i].min,
                  max: _body.prodejni_ceny[$i].max,
                  labels: {
                    formatter: function (value) {
                      return value.toFixed(2) + " " + this;
                    }.bind(_zkratka)
                  },
                },
                tooltip: {
                  x: {
                    formatter: function (value) {
                      return moment(value*1000).format("D.M.Y HH:mm");
                    }
                  }
                }
              },
              series: [{
                name: "Prodej " + _body.prodejni_ceny[$i].mena.identifikator,
                data: _body.prodejni_ceny[$i].ceny.map((e) => { 
                  return [
                    e.cas,
                    e.cena
                  ];
                })
              }]
            });
          }
          if(this.item.skryt_eshop_vykup_cena === false) {
            for (var $i = 0; $i < _body.vykupni_ceny.length; $i++) {
              var _zkratka = _body.prodejni_ceny[$i].mena.zkratka;
              this.charts.push({
                options: {
                  title: {
                    text: "Výkup " + _body.vykupni_ceny[$i].mena.identifikator,
                    align: "center",
                    style: {
                      fontSize: '22px'
                    },
                  },
                  chart: {
                    id: 'produkt-price-vykup-' + _body.prodejni_ceny[$i].mena.identifikator
                  },
                  xaxis: {
                    type: "datetime",
                    labels: {
                      formatter: function (value) {
                        return moment(value * 1000).format("D.M.Y HH:mm");
                      }
                    }
                  },
                  yaxis: {
                    min: _body.vykupni_ceny[$i].min,
                    max: _body.vykupni_ceny[$i].max,
                    labels: {
                      formatter: function (value) {
                        return value.toFixed(2) + " " + this;
                      }.bind(_zkratka)
                    },
                  },
                  tooltip: {
                    x: {
                      formatter: function (value) {
                        return moment(value * 1000).format("D.M.Y HH:mm");
                      }
                    }
                  }
                },
                series: [{
                  name: "Výkup " + _body.vykupni_ceny[$i].mena.identifikator,
                  data: _body.vykupni_ceny[$i].ceny.map((e) => {
                    return [
                      e.cas,
                      e.cena
                    ];
                  })
                }]
              });
            }
          }
          //this.priceChart.series = series;
          this.chartLoaded = true;
        }).catch((err) => {
          console.log(err);
        });
      },
      koupit () {
        this.mnozstvi = 1;
        this.basketDialog = true;
      },
      addBasket () {
        if (this.mnozstvi > 0) {
          window.API.post("kosik", {
            produkt: parseInt(this.id),
            mnozstvi: this.mnozstvi
          }).then(function(body) {
            window.kosik.changed();
            this.basketDialog = false;
            this.addBasketDialog = true;
          }.bind(this)).catch(function(err) {
            console.log(err);
          }.bind(this));
        }
      }
    }
  }
</script>
